export default "__VITE_ASSET__BUjasMxx__"